import { useAuthStore } from '../hooks/useAuth.js';

/**
 * Scope server-backed cache entries to the canonical Workspace and its active
 * economic Book. Company is retained only as the Control compatibility scope
 * until the Workspace-native context has resolved a Book.
 *
 * Reading Zustand imperatively keeps this helper usable in query callbacks and
 * mutation handlers while still resolving the identity at the moment the key
 * is created. Prefix keys remain compatible with TanStack Query's partial-key
 * invalidation (for example, `['transactions']` within the current scope).
 */
export function scopedQueryKey<const TKey extends readonly unknown[]>(logicalKey: TKey) {
  const { userId, workspaceId, activeBook, companyId } = useAuthStore.getState();
  const economicContext = activeBook
    ? `book:${activeBook.id}`
    : companyId
      ? `company:${companyId}`
      : null;
  return ['workspace', userId, workspaceId ?? companyId, economicContext, ...logicalKey] as const;
}
